import { firstTwoLetters, findThis, getFpRootName } from "./helpers";

const getEntrata = async function() {
  const res = await fetch('/wp-json/lyst-entrata-api/community-data/');
  if (!res.ok) {
    throw new Error('Entrata data problem') 
  }
  return res.json();
};

const groupUnitsByMainPlanAndSubPlan = function(unitCollection) {
  // root floor plan is something like A1 or B2
  // sub floor plan has the trailing finish level identifier like A1-r or B2-u 
  // NOTE: some communities don't use a hyphen between root floor plan and sub floor plan
  const subFloorPlans = unitCollection.reduce((floorPlansObj, unit) => {
    const rootFp = unit.floorPlanName.slice(0,2);
    if (!floorPlansObj[rootFp]) {
      // add root floor plan name as a key to the floorPlansObj 
      floorPlansObj[rootFp] = {};
    }
    if (!floorPlansObj[rootFp][unit.floorPlanName]) {
      // an array to hold the units of the sub floor plan
      floorPlansObj[rootFp][unit.floorPlanName] = [];
    }
    // add the unit to the array of its sub floor plan type 
    floorPlansObj[rootFp][unit.floorPlanName].push(unit);
    return floorPlansObj;
  },{});
  return subFloorPlans;
};

const getRootMinRent = function(mainPlanName, floorPlanCollection) {
  function isSubPlan(plan) { 
    if (typeof fpMapping == 'undefined') {
      return false;
    }
    const subPlans = fpMapping[mainPlanName];
    // make sure the site plan was included in mapping
    if (subPlans) {
      return subPlans.includes(`${plan.floorPlanId}`);
    } else {
      return false;
    }
  }
  function smallestRent(small, floorPlan) {
    return Math.min(small, floorPlan.minRent);
  }
  const subFloorPlanCollection = floorPlanCollection.filter(isSubPlan);
  if (Array.isArray(subFloorPlanCollection) && !subFloorPlanCollection.length) {
    // no units for this floor plan  
    return 0;
  } 
  // pass in the first minRent as the initial value to the reducer, if there is only 1 item in the array it will return this initial value
  const minRent = subFloorPlanCollection.reduce(smallestRent, subFloorPlanCollection[0].minRent);
  return minRent;
};

const getRootMaxRent = function(mainPlanName, floorPlanCollection) {
  function isSubPlan(plan) { 
    if (typeof fpMapping == 'undefined') {
      return false;
    }
    const subPlans = fpMapping[mainPlanName];
    // make sure the site plan was included in mapping
    if (subPlans) {
      return subPlans.includes(`${plan.floorPlanId}`);
    } else {
      return false;
    }
  }
  function largestRent(large, floorPlan) {
    return Math.max(large, floorPlan.maxRent);
  }
  const subFloorPlanCollection = floorPlanCollection.filter(isSubPlan);
  if (Array.isArray(subFloorPlanCollection) && !subFloorPlanCollection.length) {
    // no units for this floor plan  
    return 0;
  } 
  // pass in the first maxRent as the initial value to the reducer, if there is only 1 item in the array it will return this initial value
  const maxRent = subFloorPlanCollection.reduce(largestRent, subFloorPlanCollection[0].maxRent);
  return maxRent;
};

const subPlanDescription = function(subPlanName) {
  const suffix = subPlanName.substr(-1).toLowerCase();
  switch(suffix) {
    case 'u':
      return 'Updated';
      break; 
    case 'r':
      return 'Renovated';
      break;
    default:
      return 'Standard';
      break;
  }
};

/**
returns an array of floor plan root names like A1, A2, B1, etc
 */
const getRootFloorPlanNames = function(floorPlanCollection) {
  return floorPlanCollection.reduce((rootFloorPlanCollection, floorPlan) => {
    const thisFloorPlanRoot = firstTwoLetters(floorPlan.floorPlanName);
    const thisFloorPlanRootIn = findThis(thisFloorPlanRoot);
    if (!thisFloorPlanRootIn(rootFloorPlanCollection)) {
      rootFloorPlanCollection.push(thisFloorPlanRoot);
    }
    return rootFloorPlanCollection;
  },[]);
};

export {
  getEntrata,
  groupUnitsByMainPlanAndSubPlan,
  getRootMinRent,
  getRootMaxRent,
  subPlanDescription,
  getRootFloorPlanNames
};